<template>
  <b-container fluid>
    <b-col md="6">
      <b-card :title="title">
        <p v-if="status === 'expired'">
          Sorry, this invitation has been used. If you need a new invitation, please contact your supervisor.
        </p>

        <div v-if="status === 'pending' && !isLoggedIn">
          <p>You have been invited to join Vos Voco.</p>
          <p>{{invitation.invitation_message}}</p>
          <h3>Do you have a Vos Voco account?</h3>
          <b-button @click="signup" variant="secondary" class="mb-1">No, Create a New Account</b-button>
          <b-button @click="login" variant="primary" class="mb-1">Yes, Log In Now</b-button>
        </div>

        <div v-if="status === 'pending' && isLoggedIn">
          <p>{{invitation.invitation_message}}</p>
          <p v-if="isCompanyAdmin">You will be a company admin of {{invitation.copmany}}.</p>
          <p v-if="adminTeams.length > 0">You will be a team admin of:</p>
          <b-list-group v-if="adminTeams.length > 0" class="mb-3">
            <b-list-group-item v-for="(team, teamIndex) in adminTeams" :key="teamIndex">
              {{team.name}}
            </b-list-group-item>
          </b-list-group>

          <p v-if="memberTeams.length > 0">You will be a team member of:</p>
          <b-list-group v-if="memberTeams.length > 0" class="mb-3">
            <b-list-group-item v-for="(team, teamIndex) in memberTeams" :key="teamIndex">
              {{team.name}}
            </b-list-group-item>
          </b-list-group>
          <b-form-group v-if="isManaged">
            <b-form-checkbox v-model="acceptManage">
              Allow {{invitation.company.name}} to manage my account, including team memberships and notifications
            </b-form-checkbox>
          </b-form-group>
          <p>
            This will not create a new Vos Voco login, but allow access via your existing login
            {{loggedInUser.email}}.
          </p>
          <p>
            Your account will be subject to the
            <a href="https://www.vosvoco.com/privacy" target="_blank">Vos Voco Privacy Policy</a>.
          </p>
          <b-alert variant="danger" :show="errorMessage != null">{{errorMessage}}</b-alert>
          <p class="text-right mb-0">
            <b-button @click="decline" variant="danger" class="mb-1">Decline Invitation</b-button>
            <b-button @click="accept" variant="primary" class="mb-1">Accept Invitation</b-button>
          </p>
        </div>

      </b-card>
    </b-col>
  </b-container>
</template>

<script>
import API from '@/lib/api'
import Icon from '@/components/Icon'
// import zxcvbn from 'zxcvbn'

export default {
  name: 'Invitation',
  components: { Icon },
  data () {
    return {
      token: this.$route.params.token,
      invitation: null,
      status: 'loading',
      action: 'check',
      acceptManage: false,
      errorMessage: null
    }
  },
  computed: {
    title () {
      if (this.status === 'loading') {
        return 'Loading...'
      } else {
        return 'Your Invitation'
      }
    },
    isLoggedIn () {
      return this.$store.getters.isLoggedIn
    },
    isManaged () {
      return this.invitation != null && this.invitation.user.company_users.find((cu) => cu.is_managed) != null
    },
    isCompanyAdmin () {
      return this.invitation != null && this.invitation.user.company_users.find((cu) => cu.is_admin) != null
    },
    adminTeams () {
      if (this.invitation == null) {
        return []
      } else {
        return this.invitation.user.team_users.filter((tu) => tu.is_admin).map((tu) => tu.team)
      }
    },
    memberTeams () {
      if (this.invitation == null) {
        return []
      } else {
        return this.invitation.user.team_users.filter((tu) => tu.is_member).map((tu) => tu.team)
      }
    },
    loggedInUser () {
      return this.$store.state.user
    }
  },
  watch: {
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      API.get(`invitations/${this.token}`)
        .then((response) => {
          this.invitation = response.data.invitation
          this.status = this.invitation.status
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            this.invitation = null
            this.status = 'error'
          }
        })
    },
    login () {
      this.$router.push({ path: '/session/new', query: { return_path: `/invitations/${this.token}` } })
    },
    signup () {
      this.$router.push({ path: `/account/new/${this.token}` })
    },
    accept () {
      if (this.isManaged && !this.acceptManage) {
        this.errorMessage = `You must allow ${this.invitation.company.name} to manage your account in order to accept this invitation.`
      } else {
        this.errorMessage = null
        API.post(`/invitations/${this.token}`, {}, this.$store.getters.authHeaders)
          .then((response) => {
            this.$root.showToast('Invitation Accepted')
            API.get('account', {}, this.$store.getters.authHeaders).then((response) => {
              if (response.data != null) {
                this.$store.commit('updateUser', response.data)
                this.$router.push('/settings')
              }
            })
          })
          .catch((_) => {
            this.fetchData()
          })
      }
    },
    decline () {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Invitation.vue